export const list = [
  {
    name: 'Apple MacBook Air Laptop with M2 chip: 34.46 cm (13.6-inch) Liquid Retina Display, 8GB RAM, 256GB SSD Storage',
    image: 'https://m.media-amazon.com/images/I/719C6bJv8jL._SX679_.jpg',
    count: 1,
    id: 123,
    price: 600,
  },
  {
    name: 'boAt Rockerz 450 Bluetooth On Ear Headphones with Mic',
    image: 'https://m.media-amazon.com/images/I/51xxA+6E+xL._SX522_.jpg',
    count: 1,
    id: 124,
    price: 600,
  },
  {
    name: 'Lenovo Tab M7 3rd Gen (7 inch(17.7cm), 2 GB, 32 GB, Wi-fi Only), Iron Grey',
    image: 'https://m.media-amazon.com/images/I/71vzmyvgqfS._SX679_.jpg',
    count: 1,
    id: 125,
    price: 600,
  },
  {
    name: 'Redmi 10A (Charcoal Black, 4GB RAM, 64GB Storage)',
    image: 'https://m.media-amazon.com/images/I/71293gyogZL._SX679_.jpg',
    count: 1,
    id: 126,
    price: 600,
  },
  {
    name: 'Samsung Galaxy M53 5G (Emerald Brown, 6GB, 128GB Storage)',
    image: 'https://m.media-amazon.com/images/I/81Bf1rWLA+L._SX679_.jpg',
    count: 1,
    id: 127,
    price: 600,
  },
  {
    name: 'LzG 108 cm (43 inches) 4K Ultra HD Smart NanoCell TV 43NANO73SQA (Ashed Blue)',
    image: 'https://m.media-amazon.com/images/I/61LWRPDmN+L._SX522_.jpg',
    count: 1,
    id: 128,
    price: 600,
  },
]